import LegalLayout from '../components/LegalLayout';

const navLinks = [
  { label: 'Obchodné podmienky', href: '/obchodne-podmienky' },
  { label: 'Cookies', href: '/cookies' },
];

const sections = [
  {
    title: 'Prevádzkovateľ osobných údajov',
    content: (
      <>
        <p>Prevádzkovateľom osobných údajov v zmysle Nariadenia Európskeho parlamentu a Rady (EÚ) 2016/679 (GDPR) je:</p>
        <div className="mt-3 bg-zinc-800/40 border border-zinc-700/40 rounded-xl p-4 space-y-1">
          <p><strong className="text-zinc-300">Kamil Frajtko – Boostio</strong></p>
          <p>IČO: 54 125 481 | DIČ: 1127687165</p>
          <p>Adresa: Ruská Nová Ves 16, 080 05 Prešov</p>
          <p>Neplatca DPH</p>
          <p>E-mail: <a href="mailto:info@boostio.sk" className="text-orange-400 hover:underline">info@boostio.sk</a></p>
        </div>
      </>
    ),
  },
  {
    title: 'Aké osobné údaje zbierame',
    content: (
      <>
        <p>Zbierame len osobné údaje, ktoré sú nevyhnutné pre poskytovanie našich služieb. V závislosti od spôsobu, akým s nami komunikujete, ide o:</p>
        <ul className="list-disc pl-5 space-y-1.5 mt-3">
          <li><strong className="text-zinc-300">Kontaktné údaje</strong> - meno, e-mailová adresa, telefónne číslo (pri vyplnení kontaktného formulára)</li>
          <li><strong className="text-zinc-300">Firemné údaje</strong> - názov spoločnosti, IČO, fakturačná adresa (pri uzatvorení zmluvy)</li>
          <li><strong className="text-zinc-300">Komunikácia</strong> - obsah e-mailov a správ, ktoré nám zasielate</li>
          <li><strong className="text-zinc-300">Technické údaje</strong> - IP adresa, typ prehliadača, navštívené stránky, čas návštevy (prostredníctvom cookies)</li>
        </ul>
        <p className="mt-3">Nespracovávame citlivé osobné údaje (zdravotné informácie, biometrické údaje a podobne).</p>
      </>
    ),
  },
  {
    title: 'Účel a právny základ spracovania',
    content: (
      <>
        <div className="space-y-4 mt-1">
          {[
            {
              title: 'Plnenie zmluvy (čl. 6 ods. 1 písm. b) GDPR)',
              desc: 'Spracovanie údajov nevyhnutných pre uzatvorenie a plnenie zmluvy o poskytovaní digitálnych služieb.',
            },
            {
              title: 'Oprávnený záujem (čl. 6 ods. 1 písm. f) GDPR)',
              desc: 'Ochrana pred podvodmi, vymáhanie pohľadávok, komunikácia s existujúcimi klientmi a zlepšovanie našich služieb.',
            },
            {
              title: 'Súhlas dotknutej osoby (čl. 6 ods. 1 písm. a) GDPR)',
              desc: 'Zasielanie obchodných oznámení a newsletterov. Súhlas môžete kedykoľvek odvolať.',
            },
            {
              title: 'Zákonná povinnosť (čl. 6 ods. 1 písm. c) GDPR)',
              desc: 'Plnenie účtovných a daňových povinností - uchovávanie faktúr a zmlúv.',
            },
          ].map((item) => (
            <div key={item.title} className="border-l-2 border-orange-500/30 pl-4">
              <p className="text-zinc-300 text-sm font-medium mb-0.5">{item.title}</p>
              <p className="text-zinc-500 text-xs">{item.desc}</p>
            </div>
          ))}
        </div>
      </>
    ),
  },
  {
    title: 'Doba uchovávania osobných údajov',
    content: (
      <>
        <p>Osobné údaje uchovávame len po dobu nevyhnutnú na dosiahnutie účelu spracovania:</p>
        <ul className="list-disc pl-5 space-y-1.5 mt-3">
          <li>Zmluvné a fakturačné dokumenty: <strong className="text-zinc-300">10 rokov</strong> (zákonná povinnosť)</li>
          <li>Kontaktné formuláre a dopytovanie: <strong className="text-zinc-300">3 roky</strong> od poslednej komunikácie</li>
          <li>Súhlas na newsletter: do odvolania súhlasu, max. <strong className="text-zinc-300">5 rokov</strong></li>
          <li>Analytické cookies: podľa nastavenia - max. <strong className="text-zinc-300">26 mesiacov</strong></li>
        </ul>
        <p className="mt-3">Po uplynutí doby uchovávania sú údaje bezpečne anonymizované alebo zlikvidované.</p>
      </>
    ),
  },
  {
    title: 'Príjemcovia osobných údajov',
    content: (
      <>
        <p>Vaše osobné údaje nepredávame ani neposkytujeme tretím stranám na ich vlastné marketingové účely. Údaje môžeme zdieľať len s:</p>
        <ul className="list-disc pl-5 space-y-1.5 mt-3">
          <li><strong className="text-zinc-300">Dodávateľmi služieb</strong> - účtovník, hosting, e-mailová platforma (vždy na základe spracovateľskej zmluvy)</li>
          <li><strong className="text-zinc-300">Google LLC</strong> - analytika (Google Analytics 4) a reklamné nástroje</li>
          <li><strong className="text-zinc-300">Meta Platforms</strong> - pri správe reklamných kampaní pre klientov</li>
          <li><strong className="text-zinc-300">Štátne orgány</strong> - v prípade zákonnej povinnosti (súd, daňový úrad)</li>
        </ul>
        <p className="mt-3">Prenos údajov mimo EÚ/EHP sa uskutočňuje výlučne do krajín s rozhodnutím o primeranosti alebo na základe štandardných zmluvných doložiek.</p>
      </>
    ),
  },
  {
    title: 'Vaše práva ako dotknutej osoby',
    content: (
      <>
        <p>V súlade s GDPR máte nasledovné práva:</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mt-3">
          {[
            { icon: 'ri-eye-line', title: 'Právo na prístup', desc: 'Kedykoľvek môžete požiadať o informáciu, aké údaje o vás spracovávame.' },
            { icon: 'ri-edit-line', title: 'Právo na opravu', desc: 'Môžete požiadať o opravu nesprávnych alebo neúplných údajov.' },
            { icon: 'ri-delete-bin-line', title: 'Právo na vymazanie', desc: 'Za určitých podmienok môžete požiadať o vymazanie vašich údajov.' },
            { icon: 'ri-pause-circle-line', title: 'Právo na obmedzenie', desc: 'Môžete obmedziť spracovanie vašich údajov v zákonom stanovených prípadoch.' },
            { icon: 'ri-download-line', title: 'Právo na prenosnosť', desc: 'Môžete dostať vaše údaje v štruktúrovanom strojovo čitateľnom formáte.' },
            { icon: 'ri-close-circle-line', title: 'Právo namietať', desc: 'Môžete namietať voči spracovaniu na základe oprávneného záujmu.' },
          ].map((r) => (
            <div key={r.title} className="bg-zinc-800/30 border border-zinc-700/40 rounded-xl p-4">
              <div className="flex items-center gap-2 mb-1.5">
                <i className={`${r.icon} text-orange-400 text-sm`} />
                <p className="text-zinc-300 text-sm font-semibold">{r.title}</p>
              </div>
              <p className="text-zinc-500 text-xs leading-relaxed">{r.desc}</p>
            </div>
          ))}
        </div>
        <p className="mt-4">Žiadosti adresujte na <a href="mailto:info@boostio.sk" className="text-orange-400 hover:underline">info@boostio.sk</a>. Odpovieme do 30 dní. Máte tiež právo podať sťažnosť na <strong className="text-zinc-300">Úrad na ochranu osobných údajov SR</strong> (dataprotection.gov.sk).</p>
      </>
    ),
  },
  {
    title: 'Bezpečnosť údajov',
    content: (
      <>
        <p>Na ochranu vašich osobných údajov uplatňujeme primerané technické a organizačné opatrenia, vrátane:</p>
        <ul className="list-disc pl-5 space-y-1 mt-2">
          <li>Šifrovanie prenosu dát cez protokol HTTPS (TLS)</li>
          <li>Obmedzený prístup k údajom len pre oprávnené osoby</li>
          <li>Pravidelné zálohovanie a monitorovanie bezpečnosti</li>
          <li>Povinnosti mlčanlivosti pre všetky osoby pracujúce s údajmi</li>
        </ul>
      </>
    ),
  },
  {
    title: 'Zmeny tohto dokumentu',
    content: (
      <>
        <p>Vyhradzujeme si právo tento dokument aktualizovať. O podstatných zmenách vás budeme informovať e-mailom alebo upozornením na webovej stránke. Odporúčame pravidelne kontrolovať túto stránku.</p>
        <p className="mt-2">Tento dokument je platný od <strong className="text-zinc-300">1. januára 2024</strong>.</p>
      </>
    ),
  },
];

export default function OchranaSukromiaPage() {
  return (
    <LegalLayout
      title="Ochrana osobných údajov"
      subtitle="Informácie o spracovaní osobných údajov podľa nariadenia GDPR (EÚ) 2016/679."
      updated="1. januára 2024"
      sections={sections}
      navLinks={navLinks}
    />
  );
}
